<template>
  <div
    class="button-full-screen"
    @click="click">
  </div>
</template>

<script>
export default {
  props: {
    action: {
      required: true,
      type: Function
    }
  },

  methods: {
    click: function () {
      this.action()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-full-screen {
  top: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  z-index: 100;

  &:hover {
    cursor: pointer;
  }
}
</style>
